import { useContext } from 'react';
import { CurrencyPairContext } from '.';
// If this file cannot be found, you need to generate it using "npm run extract-ccy"
import { currencies } from '@/data/currencies';

export function usePrecision() {
  const ccyPair = useContext(CurrencyPairContext);
  return currencies[ccyPair]?.precision ?? 5;
}
